export default __webpack_public_path__ + "static/media/meyer.44938e5d.jpeg";